import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { MainLayout, SideMenu } from 'components';
import {
  fetchCurrentEmployee,
  fetchEmployees,
  fetchUserGroups,
  fetchCurrentUserRights,
} from 'rdx/users';
import {
  setSettings,
  fetchCurrencies,
  fetchServiceEndpoints,
} from 'rdx/config';
import { fetchVatRates } from 'rdx/vatRates';
import { fetchWarehouses } from 'rdx/warehouses';
import { fetchPointsOfSale } from 'rdx/pointsOfSale';
import { fetchCurrentEmployeeAddress, fetchAddressTypes } from 'rdx/addresses';
import { initialInstallerFetch } from 'rdx/hardware';
import { getCompanyInfo } from 'rdx/company';
import { getIsLoggedIn } from 'rdx/auth';
import { useLogin } from 'containers/LoginApp/LoginApp';
import { fetchPOSAvailableVersionsAndSetToLS } from 'utils';

export default function ({ links, main }) {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  useLogin();
  useEffect(() => {
    // bulkyFetch
    if (isLoggedIn) {
      dispatch(fetchCurrentEmployee());
      dispatch(fetchServiceEndpoints());
      dispatch(fetchEmployees());
      dispatch(fetchUserGroups());
      dispatch(fetchCurrentEmployeeAddress());
      dispatch(setSettings());
      dispatch(fetchVatRates());
      dispatch(fetchAddressTypes());
      dispatch(fetchWarehouses());
      dispatch(fetchPointsOfSale());
      dispatch(fetchCurrencies());
      dispatch(getCompanyInfo());
      dispatch(initialInstallerFetch());
      dispatch(fetchCurrentUserRights());
      fetchPOSAvailableVersionsAndSetToLS();
    }
  }, [dispatch, isLoggedIn]);

  return <MainLayout sidebar={<SideMenu options={links} />} main={main} />;
}
